import { AccountSlice, AccountState } from 'modules/account/types';
import { INITIAL_ACCOUNT_STATE } from 'modules/account/const';

import { AccountAction } from '../types';

export interface UpdateAccountStateParams<Key extends keyof AccountState> {
  action: AccountAction<Key>;
  state: AccountSlice;
}

export const updateAccountState = <Key extends keyof AccountState>({
  action,
  state,
}: UpdateAccountStateParams<Key>) => {
  const {
    payload: { authAddress, ...payload },
  } = action;

  const address = authAddress.toLowerCase();

  state[address] = {
    ...(state[address] ?? INITIAL_ACCOUNT_STATE),
    ...payload,
  };
};
